export default "/images/statistics.png?6211a95e756270b3199cce4f56450f7f";